export const CardEmptyState = 'CardEmptyState';
export const ChickletPrimaryDisplayLabel = 'ChickletPrimaryDisplayLabel';
export const ChickletHoverActions = 'ChickletHoverActions';
export const CardAction = 'CardAction';
export const ChickletSecondaryDisplayLabels = 'ChickletSecondaryDisplayLabels';
export const CardBottomContent = 'CardBottomContent';
export const CardFooterAction = 'CardFooterAction';